/* @flow */
/* eslint import/no-commonjs: off */

// $FlowFixMe
module.exports = require('./dist/checkout.lib');

module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./~/paypal-checkout/index.js
// module id = 496
// module chunks = 1